// extracted by mini-css-extract-plugin
module.exports = {"nameSummary":"style-module_nameSummary__zbpLoD3TWIHQ24tNuhXw","slugSummary":"style-module_slugSummary__k7BhoJjRcYrcSpu9IkLa"};